import { render, staticRenderFns } from "./PdfScrollViewer.vue?vue&type=template&id=8cad1a2c&scoped=true"
import script from "./PdfScrollViewer.vue?vue&type=script&lang=js"
export * from "./PdfScrollViewer.vue?vue&type=script&lang=js"
import style0 from "./PdfScrollViewer.vue?vue&type=style&index=0&id=8cad1a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cad1a2c",
  null
  
)

export default component.exports